// ─── AI reading / analysis tools ─────────────────────────────────────────────
// Tools surfaced in the "Analyze with AI" card. This is NOT a blog concept —
// any long-form content page (case studies, whitepapers, docs) can show this card.
// Add or remove entries here; the AiToolsCard component renders whatever is in this array.

import {cdnUrl} from '@/util/cdnImage';
import {colors} from '@/styles/tokens';

export const AI_TOOLS = [
    {
        name: 'Claude',
        by: 'Anthropic',
        showBy: true,
        action: 'Open · paste · analyze',
        // Base URL that accepts a pre-filled prompt via the `q` query param.
        // The article title + URL are injected at render time (see buildAiPromptUrl).
        href: 'https://claude.ai/new',
        promptParam: 'q',
        iconSrc: cdnUrl('blog/Claude1.webp'),
        bgColor: colors.background.default
    },
    {
        name: 'ChatGPT',
        by: 'OpenAI',
        showBy: true,
        action: 'Open · paste · analyze',
        href: 'https://chatgpt.com/',
        promptParam: 'q',
        iconSrc: cdnUrl('blog/chatgpt.webp'),
        bgColor: colors.background.orangeTint
    },
    {
        name: 'Copy for Agent',
        by: 'any LLM',
        showBy: false,
        action: 'Copy prompt + article link',
        href: null,
        promptParam: null,
        iconSrc: cdnUrl('blog/code-icon.svg'),
        bgColor: colors.background.default
    }
] as const;

// ─── AI analysis prompt ──────────────────────────────────────────────────────
// Pre-filled prompt sent to the AI tool. Title + URL are interpolated so the
// model has the article as primary context before the user types anything.

export const buildAiPrompt = (title: string, url: string): string =>
    `Title: ${title}
URL: ${url}
Please use this article as the primary context and help me understand and apply the information.
Start by providing:
A concise summary of the article
The most important takeaways
Practical business or technical applications
Key risks, limitations, or considerations
Recommended next steps based on the topic`;

// Builds the full deep-link for a prompt-aware tool (Claude / ChatGPT).
// Falls back to the bare base URL when title/url aren't available yet.
export const buildAiPromptUrl = (baseHref: string, promptParam: string, title: string, url: string): string => {
    if (!title || !url) return baseHref;
    return `${baseHref}?${promptParam}=${encodeURIComponent(buildAiPrompt(title, url))}`;
};
